<div class="right-panel custom-scroll">
  <!-- Panel Header -->
  @if (campusMapEntity?.type === 'CampusMapEntity') {
  <div style="border: 0.5px solid #eee;" class="p-2">
    <div class="panel-header pb-1 d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center gap-2">
        <span>Campus : {{campusMapEntity?.name}}</span>
        <button type="button" class="btn btn-sm btn-light threed-toggle-btn position-relative overflow-hidden"
          (click)="showAllBuildings3D()" [disabled]="isCampus3dBuildingLoading">
          @if (isCampus3dBuildingLoading) {
          <div class="btn-progress-fill" [style.width.%]="buildingProgressPercent"></div>
          <i class="fa-solid fa-spinner fa-spin me-1"></i>
          Building... {{ buildingProgressPercent }}%
          } @else {
          <i class="fa-solid fa-building me-1"></i>
          {{ isGlbViewerActive() ? 'Show Existing View' : 'Show All Buildings' }}
          }
        </button>
      </div>
      <i class="fas fa-times cursor-pointer" (click)="closePanel()"></i>
    </div>

    @if (enableMonitor || (enableInteraction && hideEventDetailsForLiveNotification)) {
    <div class="panel panel-default">
      <div class="create-incident">
        <div class="panel-header">
          <span>Create Campus Incident</span>
        </div>
      </div>
      <div class="create-incident">
        <div class="incident-actions">
          @for (cat of incidentCampusCategoryList | slice:0:4; track cat) {
          <button type="button" class="btn btnInciden panic-button-tiny panic-button-tiny-icon p-0"
            (click)="panicButtonPressed(cat, true)">
            <img [src]="'assets/img/glyphicons/glyphicons-' + cat.iconCode + '.png'" class="icon_border"
              [attr.title]="cat.label" alt="{{ cat.label }}" />
          </button>
          }
          <button class="btn btnInciden panic-button-tiny panic-button-tiny-icon"
            (click)="panicButtonPressed(null, true)">
            <i class="fa fa-pencil text-white icon_i"></i>
          </button>
        </div>
      </div>
    </div>
    }
    <!-- Incident Panel -->
    @if (!hideEventDetailsForLiveNotification) {
    <div class="panel panel-default mb-0">
      <div class="panel-header">
        {{ eventMapEntity?.getName() }}
        @if (alert) {
        <span (click)="showAlert(alert)" class="float-end" style="cursor: pointer"> Alert Info</span>
        }
      </div>
      <div class="panel-body p1">
        <div class="row">
          <div class="col-2">
            <div class="d-inline-block">Status:</div>
          </div>
          @if (eventMapEntity?.getStatus() === 'active') {
          <div class="col-10">
            <span class="badge bg-danger px-3 py-2 align-middle">Active</span>
            @if (enableInteraction) {
            <button type="button" class="btn btn-primary float-end" (click)="resolveEvent()">
              Resolve
              <i class="fa fa-thumbs-o-up ms-2" aria-hidden="true"></i>
            </button>
            }
          </div>
          }
          @if (eventMapEntity?.getStatus() === 'pending') {
          <div class="col-md-10">
            <span class="badge bg-info text-dark px-3 py-2 align-middle">Pending</span>
            <div class="float-end">
              @if (enableInteraction) {
              <button type="button" class="btn btn-danger" (click)="activateEvent()">
                Activate
                <i class="fa fa-bolt ms-2" aria-hidden="true"></i>
              </button>
              }
              @if (enableInteraction) {
              <button type="button" class="btn btn-primary ms-2" (click)="closeEvent()">
                Close
                <i class="fa fa-times-circle ms-2" aria-hidden="true"></i>
              </button>
              }
            </div>
          </div>
          }
          @if (enablePlayback &&
          (eventMapEntity?.getStatus() === 'inactive' ||
          eventMapEntity?.getStatus() === 'resolved')) {
          <div class="col-md-10">
            <span class="badge bg-primary-resolved px-3 py-2 align-middle">Resolved</span>
          </div>
          }
          @if (eventMapEntity?.getStatus() === 'closed') {
          <div class="col-md-10">
            <span class="badge bg-primary px-3 py-2 align-middle">Closed</span>
          </div>
          }
        </div>
      </div>
      <div class="row">
        @if (enablePlayback && eventMapEntity && eventMapEntity.getStatus() !== 'active') {
        <div class="col-md-12">
          <div class="centering-container">
            <div class="d-inline-block fs-6">Duration(UTC): <i>{{ getStartTime() }} to {{ getEndTime() }}</i></div>
          </div>
          <div class="centering-container">
            <div class="d-inline-block fs-6">Total Time: {{ getTotalElapsedTime() }} | Elapsed: {{
              getCurrentIncidentTime() }} ({{ getElapsedTimePct() }}%)</div>
          </div>
        </div>
        }
        @if (eventMapEntity && eventMapEntity.getStatus() === 'active') {
        <div class="col-md-12">
          <div class="centering-container">
            <div class="fs-6 me-3"><i>Started: {{ getStartTime() }} UTC | Elapsed: {{ getCurrentIncidentTime() }} </i>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
    }
    <div class="mt-2 user-stats">
      <h6 class="user-count">Total Campus Affected Users: <strong>{{ getCampusTotalCountAll() }}</strong>
        @if (enableInteraction) {
        <div class="d-flex">
          <div><i class="fas fa-envelope text-info email-icon" (click)="sendMessageToAll()"></i></div>
          <div class="d-inline-block ms-3"><i class="fa fa-search" (click)="openSearchUserBox()"
              title="search users"></i>
          </div>
        </div>
        }
      </h6>

      <div class="user-superscript pt-0">
        <!-- Danger Users -->
        <span class="text-danger position-relative d-inline-block">
          <i class="fas fa-user" title="Danger"></i>
          <sup>
            <span class="badge bg-light text-dark">{{ getCampusDangerCountAll() }}</span>
          </sup>
          @if (enableInteraction) {
          <div>
            <i class="fas fa-envelope text-info email-icon" (click)="sendMessageToInDangerUsers()"></i>
          </div>
          }
        </span>

        <!-- Safe Users -->
        <span class="text-success ms-2">
          <i class="fas fa-user" title="Safe"></i>
          <sup><span class="badge bg-light text-dark">{{ getCampusSafeCountAll() }}</span></sup>
          @if (enableInteraction) {
          <div>
            <i class="fas fa-envelope text-info email-icon" (click)="sendMessageToSafeUsers()"></i>
          </div>
          }
        </span>

        <!-- Unknown Users -->
        <span class="text-warning ms-2">
          <i class="fas fa-user" title="Unknown"></i>
          <sup><span class="badge bg-light text-dark">{{ getCampusUnknownMinusSuspectCount() }}</span></sup>
          @if (enableInteraction) {
          <div>
            <i class="fas fa-envelope text-info email-icon" (click)="sendMessageToUnknownUsers()"></i>
          </div>
          }
        </span>

        <!-- First Responders -->
        <!-- <span class="text-light ms-2">
          <i class="fas fa-user" title="First Responder"></i>
          <sup><span class="badge bg-light text-dark">0</span></sup>
          <div *ngIf="enableInteraction">
            <i class="fas fa-envelope text-info email-icon" (click)="sendMessageToFirstResponders()"></i>
          </div>
        </span> -->

        <!-- Suspect Users -->
        <!-- <span class="text-suspect ms-2">
        <i class="fas fa-user" title="Suspect"></i>
        <sup><span class="badge bg-light text-dark">{{ getCampusSuspectCountAll() }}</span></sup>
        <div *ngIf="enableInteraction">
          <i class="fas fa-envelope text-info email-icon"></i>
        </div>
      </span> -->
      </div>
    </div>
    <div class="mb-1 mt-1">
      <h6 class="user-count">Associated Buildings: </h6>
      <select class="form-select" (change)="onBuildingChange($event)"
        style="height: 30px; display: inline-block; padding: 2px; font-size: 14px" title="Building">
        <option value="" disabled>Select Building</option>

        @for (building of campusBuildings; track building) {
        <option [value]="building.perimeterId" [selected]="building.perimeterId == buildingMapEntity?.perimeterId">
          {{ building.name }}
        </option>
        }
      </select>
    </div>
  </div>
  } <div class="panel-header mt-2 mb-2 d-flex justify-content-between align-items-center flex-wrap gap-2">
    <div class="header-controls">
      <span>{{ buildingMapEntity?.name }}</span>
      <button type="button" class="btn btn-sm btn-light threed-toggle-btn position-relative overflow-hidden"
        (click)="toggleSingleBuilding3dViewer()"
        [disabled]="isSingleBuilding3dLoading || (!isSingleBuildingGlbActive() && !is3dViewAvailable)">
        @if (isSingleBuilding3dLoading) {
        <div class="btn-progress-fill" [style.width.%]="singleBuildingProgressPercent"></div>
        <i class="fa-solid fa-spinner fa-spin me-1"></i>
        Building... {{ singleBuildingProgressPercent }}%
        } @else {
        <i class="fa-solid fa-cube me-1"></i>
        {{ isSingleBuildingGlbActive() ? 'Show Existing View' : 'Show 3D View' }}
        }
      </button>
    </div>
    @if (campusMapEntity?.type != 'CampusMapEntity') {
    <i class="fas fa-times cursor-pointer" (click)="closePanel()"></i>
    }
  </div>
  <!-- Temporary: hide entire vehicle Playback panel (controls, status, legend, alerts). Cars still run via Vehicle View. -->
  @if (false) {
  <div class="vehicle-playback">
    <button type="button" class="vehicle-playback-toggle" (click)="vehiclePlaybackOpen = !vehiclePlaybackOpen">
      <span>
        Playback
        <!-- Temporary: hide unauthorized-vehicle alert badge
        @if (vehicleSnapshot?.alerts?.length) {
          <span class="vehicle-alert-count">{{ vehicleSnapshot?.alerts?.length }}</span>
        }
        -->
      </span>
      <i class="fa-solid" [class.fa-chevron-down]="!vehiclePlaybackOpen"
        [class.fa-chevron-up]="vehiclePlaybackOpen"></i>
    </button>
    @if (vehiclePollError) {
    <div class="vehicle-alert">{{ vehiclePollError }}</div>
    }
    <!-- Temporary: hide unauthorized-vehicle alert rows
    @if (vehicleSnapshot?.alerts?.length) {
      <div class="vehicle-alerts">
        @for (alert of vehicleSnapshot?.alerts ?? []; track alert.trackerId) {
          <div class="vehicle-alert">{{ alert.message }}</div>
        }
      </div>
    }
    -->
    @if (vehiclePlaybackOpen) {
    <div class="vehicle-playback-body">
      <div class="vehicle-playback-status">
        {{ vehicleSnapshot?.site?.siteName || vehicleSnapshot?.id }}
        · {{ vehicleSnapshot?.simulation?.state || 'STOPPED' }}
        · step {{ vehicleSnapshot?.simulation?.step || 0 }}/{{ vehicleSnapshot?.simulation?.totalSteps || 0 }}
        · {{ vehicleSnapshot?.simulation?.speed || 1 }}x
      </div>
      <div class="vehicle-legend">
        <span class="vehicle-legend-known">Known / registered</span>
        <span class="vehicle-legend-unknown">Unknown</span>
      </div>
      <div class="vehicle-playback-actions">
        <button type="button" (click)="sendVehicleCommand('start')">Start</button>
        <button type="button" (click)="sendVehicleCommand('pause')">Pause</button>
        <button type="button" (click)="sendVehicleCommand('resume')">Resume</button>
        <button type="button" (click)="sendVehicleCommand('stop')">Stop</button>
        <button type="button" (click)="sendVehicleCommand('reset')">Reset</button>
        <button type="button" (click)="sendVehicleCommand('reload')">Reload JSON</button>
      </div>
      <div class="vehicle-playback-speeds">
        @for (speed of vehicleSpeeds; track speed) {
        <button type="button" [class.active]="vehicleSnapshot?.simulation?.speed === speed"
          (click)="sendVehicleCommand('speed', speed)">{{ speed }}x</button>
        }
      </div>
    </div>
    }
  </div>
  }
  @if (vehicleViewOn && selectedVehicle) {
  <div class="vehicle-popup" [class.unknown]="!selectedVehicle.authorized">
    <button type="button" class="vehicle-popup-close" (click)="closeVehiclePopup()"
      aria-label="Close vehicle details">×</button>
    <div class="vehicle-popup-title">{{ selectedVehicle.authorized ? (selectedVehicle.vehicleNo ||
      selectedVehicle.trackerId) : 'Unknown vehicle' }}</div>
    <div class="vehicle-popup-status">{{ selectedVehicle.authorized ? 'Registered / authorized' : 'Unauthorized' }}
    </div>
    <dl class="vehicle-popup-list">
      <dt>trackerId</dt>
      <dd>{{ selectedVehicle.trackerId }}</dd>
      <dt>vehicleNo</dt>
      <dd>{{ selectedVehicle.vehicleNo || 'Not available' }}</dd>
      @if (selectedVehicle.registration; as registration) {
      <dt>Make / model</dt>
      <dd>{{ registration.make }} {{ registration.model }}</dd>
      <dt>Driver</dt>
      <dd>{{ registration.driverName || 'Not available' }}</dd>
      <dt>License</dt>
      <dd>{{ registration.licenseNo || 'Not available' }}</dd>
      }
      <dt>Road</dt>
      <dd>{{ selectedVehicle.roadName || 'Not available' }}</dd>
      <dt>Speed</dt>
      <dd>{{ selectedVehicle.speedKph }} km/h</dd>
    </dl>
  </div>
  }
  @if (enableMonitor || (enableInteraction && hideEventDetailsForLiveNotification)) {
  <div class="panel panel-default">
    <div class="create-incident">
      <div class="panel-header">
        <span>Create {{ buildingMapEntity?.name }} Incident</span>
      </div>
    </div>
    <div class="create-incident">
      <div class="incident-actions">
        @for (cat of incidentCategoryList | slice:0:4; track cat) {
        <button type="button" class="btn btnInciden panic-button-tiny panic-button-tiny-icon p-0"
          (click)="panicButtonPressed(cat, false)">
          <img [src]="'assets/img/glyphicons/glyphicons-' + cat.iconCode + '.png'" class="icon_border"
            [attr.title]="cat.label" alt="{{ cat.label }}" />
        </button>
        }
        <button class="btn btnInciden panic-button-tiny panic-button-tiny-icon"
          (click)="panicButtonPressed(null, false)">
          <i class="fa fa-pencil text-white icon_i"></i>
        </button>
      </div>
    </div>
  </div>
  }
  @if (!hideEventDetailsForLiveNotification) {
  <div class="panel panel-default mb-0">
    @if (campusMapEntity?.type != 'CampusMapEntity') {
    <div class="panel-header">
      {{ eventMapEntity?.getName() }}
      @if (alert) {
      <span (click)="showAlert(alert)" class="float-end" style="cursor: pointer"> Alert Info</span>
      }
    </div>
    <div class="panel-body p1">
      <div class="row">
        @if (eventMapEntity?.getStatus() === 'active' || eventMapEntity?.getStatus() === 'pending' ||
        eventMapEntity?.getStatus() === 'resolved' ) {
        <div class="col-2">
          <div class="d-inline-block">Status:</div>
        </div>
        }
        @if (eventMapEntity?.getStatus() === 'active') {
        <div class="col-10">
          <span class="badge bg-danger px-3 py-2 align-middle">Active</span>
          @if (enableInteraction) {
          <button type="button" class="btn btn-primary float-end" (click)="resolveEvent()">
            Resolve
            <i class="fa fa-thumbs-o-up ms-2" aria-hidden="true"></i>
          </button>
          }
        </div>
        }
        @if (eventMapEntity?.getStatus() === 'pending') {
        <div class="col-md-10">
          <span class="badge bg-info text-dark px-3 py-2 align-middle">Pending</span>
          <div class="float-end">
            @if (enableInteraction) {
            <button type="button" class="btn btn-danger" (click)="activateEvent()">
              Activate
              <i class="fa fa-bolt ms-2" aria-hidden="true"></i>
            </button>
            }
            @if (enableInteraction) {
            <button type="button" class="btn btn-primary ms-2" (click)="closeEvent()">
              Close
              <i class="fa fa-times-circle ms-2" aria-hidden="true"></i>
            </button>
            }
          </div>
        </div>
        }
        @if (eventMapEntity?.getStatus() === 'inactive' || eventMapEntity?.getStatus() === 'resolved') {
        <div class="col-md-10">
          <span class="badge bg-primary-resolved px-3 py-2 align-middle">Resolved</span>
        </div>
        }
        @if (eventMapEntity?.getStatus() === 'closed') {
        <div class="col-md-10">
          <span class="badge bg-primary px-3 py-2 align-middle">Closed</span>
        </div>
        }
      </div>
    </div>
    <div class="row">
      @if (eventMapEntity && eventMapEntity.getStatus() !== 'active') {
      <div class="col-md-12">
        <div class="centering-container">
          <div class="d-inline-block fs-6">Duration(UTC): <i>{{ getStartTime() }} to {{ getEndTime() }}</i></div>
        </div>
        <div class="centering-container">
          <div class="d-inline-block fs-6">Total Time: {{ getTotalElapsedTime() }} | Elapsed: {{
            getCurrentIncidentTime()
            }} ({{ getElapsedTimePct() }}%)</div>
        </div>
      </div>
      }
      @if (eventMapEntity && eventMapEntity.getStatus() === 'active') {
      <div class="col-md-12">
        <div class="centering-container">
          <div class="fs-6 me-3"><i>Started: {{ getStartTime() }} UTC | Elapsed: {{ getCurrentIncidentTime() }} </i>
          </div>
        </div>
      </div>
      }
    </div>
    }
  </div>
  }
  <!-- Total Affected Users (Single Line with <sup>) -->
  <div class="user-stats">
    <h6 class="user-count">Total {{ buildingMapEntity?.name }} Affected Users: <strong>{{ getTotalCountAll() }}</strong>
      @if (enableInteraction) {
      <div class="d-flex">
        <div><i class="fas fa-envelope text-info email-icon" (click)="sendMessageToAll()"></i></div>
        <div class="d-inline-block ms-3"><i class="fa fa-search" (click)="openSearchUserBox()" title="search users"></i>
        </div>
      </div>
      }
    </h6>

    <div class="user-superscript">
      <!-- Danger Users -->
      <span class="text-danger position-relative d-inline-block">
        <i class="fas fa-user" title="Danger"></i>
        <sup>
          <span class="badge bg-light text-dark">{{ getInDangerUserCountAll() }}</span>
        </sup>
        @if (enableInteraction) {
        <div>
          <i class="fas fa-envelope text-info email-icon" (click)="sendMessageToInDangerUsers()"></i>
        </div>
        }
      </span>

      <!-- Safe Users -->
      <span class="text-success ms-2">
        <i class="fas fa-user" title="Safe"></i>
        <sup><span class="badge bg-light text-dark">{{ getSafeUserCountAll() }}</span></sup>
        @if (enableInteraction) {
        <div>
          <i class="fas fa-envelope text-info email-icon" (click)="sendMessageToSafeUsers()"></i>
        </div>
        }
      </span>

      <!-- Unknown Users -->
      <span class="text-warning ms-2">
        <i class="fas fa-user" title="Unknown"></i>
        <sup><span class="badge bg-light text-dark">{{ getUnknownMinusSuspectCount() }}</span></sup>
        @if (enableInteraction) {
        <div>
          <i class="fas fa-envelope text-info email-icon" (click)="sendMessageToUnknownUsers()"></i>
        </div>
        }
      </span>

      <!-- First Responders -->
      <!-- <span class="text-light ms-2">
  <i class="fas fa-user" title="First Responder"></i>
  <sup><span class="badge bg-light text-dark">0</span></sup>
  <div *ngIf="enableInteraction">
    <i class="fas fa-envelope text-info email-icon" (click)="sendMessageToFirstResponders()"></i>
  </div>
</span> -->

      <!-- Suspect Users -->
      <!-- <span class="text-suspect ms-2">
<i class="fas fa-user" title="Suspect"></i>
<sup><span class="badge bg-light text-dark">{{ getInSuspectUserCountAll() }}</span></sup>
<div *ngIf="enableInteraction">
  <i class="fas fa-envelope text-info email-icon"></i>
</div>
</span> -->
    </div>
  </div>

  <!-- Floor Summary -->
  <div class="floor-summary">
    <!-- 3D View Status -->
    <div class="floor-scroll" #floorScroll>
      @for (floor of floorsDetails; track trackByPerimeterId(i, floor); let i = $index) {
      <div class="floor-row" [id]="'floor-row-' + i" (click)="viewFloorDetail(floor, i)"
        [class.active]="activeFloorIndex === i">
        <div class="floor-label">{{ floor.label }}</div>
        <div class="color-boxes">
          <div class="color-box danger-incident">{{getNumberOfUnSafeUsers(floor)}}</div>
          <div class="color-box safe-incident">{{getNumberOfSafeUsers(floor) }}</div>
          <div class="color-box unknown-incident text-dark">{{getNumberOfUnknownUsers(floor)}}</div>
          <!-- <div class="color-box first-response text-dark">0</div>
          <div class="color-box suspect-ncident text-dark">{{ getNumberOfSuspectUsers(floor) }}</div> -->
        </div>
      </div>
      }
      <div class="floor-row" (click)="viewStreet(-1)" [class.active]="activeFloorIndex === -1">
        <div class="floor-label">STREET</div>
        <div class="color-boxes">
          <div class="color-box danger-incident">{{ numberOfDangerUserOnStreet }}</div>
          <div class="color-box safe-incident">{{ numberOfSafUserOnStreet }}</div>
          <div class="color-box unknown-incident text-dark">{{ numberOfUnknownUserOnStreet }}</div>
          <!-- <div class="color-box first-response text-dark">{{ getNumberOfFirstRespondersForStreet() }}</div>
        <div class="color-box suspect-ncident text-dark">{{ getNumberOfIncidentUpdatesOnStreetNewWithSuspectCount() }}
        </div> -->
        </div>
      </div>
    </div>
  </div>

  <hr class="my-2" />

  <!-- Location Info -->
  <div class="legend mt-1">
    {{ fullAddress }}

    Floors: {{ numFloor }} | Top Floor Height: {{ topFloorHeight }} ft | Total Area: {{ areaTotal }} ft² | Max Floor
    Area: {{ areaMax }} ft² | Min Floor Area: {{ areaMin }} ft² |
    Average Floor Area: {{ areaMean }} ft²
  </div>

  @if (enablePlayback) {
  <div class="row mt-0">
    <div class="col-lg-12">
      <hr class="w-100 my-2" />
      Recorded Video During This Incident ({{playbackCameraSessions.length}})
      <table class="w-100">
        <tr class="border-bottom-gray">
          <td>Camera Name</td>
          <td>Session</td>
          <td>Start</td>
          <td>End</td>
          <td>Duration</td>
        </tr>
        <tr ng-repeat="session in playbackCameraSessions">
          <td>
            <i class="fa fa-video-camera" style="cursor: pointer" title="play" ng-click="playbackVideo(session)"></i>
            <!-- <span title="{{session.camera.label}}">{{session.camera.labelShort}}</span> -->
          </td>
          <!-- <td>{{session.id}}</td>
          <td>{{session.startTime.slice(11, 19)}}</td>
          <td>{{session.endTime.slice(11, 19)}}</td>
          <td>{{session.duration}}</td> -->
        </tr>
      </table>
    </div>
  </div>
  }
</div>
<app-blender-camera #blenderCamera [buildingMapEntity]="buildingMapEntity" [campusMapEntity]="campusMapEntity"
  [campusBuildings]="campusBuildings" [lastFloorStatus]="lastFloorStatus" [currentFloorData]="currentFloorData"
  [floorsDetails]="floorsDetails" [userByPerimeter]="userByPerimeter"
  (buildingProgressChange)="onBuildingProgressChange()" (floorSelected)="onFloorSelectedFromBlender($event)" />
@if (floorService.floorMapVisibility$ | async) {
<app-floor-visualizer [floorMapEntity]="floorMapEntity" [liveData]="eventMapEntity" [liveUserData]="viewerLiveUserData"
  [assetResolutionKey]="buildingAssetResolutionKey" [alertRecords]="viewerAlertRecords"></app-floor-visualizer>
}
@if (floorService.incidentVisualizerVisibility$ | async) {
<app-incident-visualizer [mapentityid]="mapentityid" [liveData]="eventMapEntity"
  [highGeometryLocation]="highGeometryLocation" [buildingId]="buildingId"
  (addSafeZoneStatus)="onSafeZoneStatusChanged($event)"></app-incident-visualizer>
}
@if (isSafeZoneMode) {
<app-safezone-creator [eventId]="eventMapEntity?.eventId" (addSafeZoneStatus)="onSafeZoneStatusChanged($event)"
  (done)="onSafezoneCreated($event)"></app-safezone-creator>
}

<ng-template #noUsersModal let-modal>
  <div class="modal-header bg-primary text-white d-flex align-items-center justify-content-between">
    <div>
      <span class="session-header-title">Notification</span>
    </div>
    <button type="button" class="close-button" aria-label="Close" (click)="modal.dismiss()">×</button>
  </div>
  <div class="modal-body">
    <label>No users to notify</label>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="modal.close()">Ok</button>
  </div>
</ng-template>